export const SYSTEM_DEFAULT_CRITERIA_OPTIONS = [
  { "id": "MAIN_MENU", "value": "menu.top", "label": "Idle Time(Minutes)" },
  { "id": "DEVICE_MAP", "value": "map.device", "label": "Device Map" },
  { "id": "DASHBOARD", "value": "menu.dashDetail", "label": "Dashboard" },
  { "id": "FLEET_MAP", "value": "map.fleet", "label": "Fleet Map" },
];

export const SYSTEM_FREQUENCY_OPTIONS = [
  { "id": "YES", "value": "yes", "label": "Yes" },
  { "id": "NO", "value": "no", "label": "No" },
];

export const SYSTEM_INTERVAL_OPTIONS = Array.from({ length: 61 }, (_, index) => ({
  id: index.toString(),
  value: index.toString(),
  label: index.toString()
}));

export const SYSTEM_NOTIFICATION_VARIABLES = [
  { "id": "YES", "value": "yes", "label": "Yes" },
  { "id": "NO", "value": "no", "label": "No" },
];

export const SYSTEM_ASSETS_OPTIONS = [
  { "id": "YES", "value": "yes", "label": "Yes" },
  { "id": "NO", "value": "no", "label": "No" },
];

export const SYSTEM_GROUPS_OPTIONS = [
  { "id": "YES", "value": "yes", "label": "Yes" },
  { "id": "NO", "value": "no", "label": "No" },
];

// Original Values

export const SYSTEM_CRON_RULE_OPTIONS = [
  { "id": "NO", "value": "0", "label": "No" },
  { "id": "YES", "value": "1", "label": "Yes" },
  { "id": "MINUTE30", "value": "30min", "label": "30 Minute" },
  { "id": "HOURLY", "value": "hourly", "label": "Hourly" },
  { "id": "DAILY", "value": "daily", "label": "Daily" },
  { "id": "WEEKLY", "value": "weekly", "label": "Weekly" },
  // { "id": "MONTHLY", "value": "monthly", "label": "Monthly" }, // disabled as this is not supported and backend gives error
]
